import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InMemoryCacheService } from 'src/app/common';

@Component({
  selector: 'gig-project-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './project-header.component.html',
  styleUrls: ['./project-header.component.scss']
})
export class ProjectHeaderComponent implements OnInit {

  constructor(public cache: InMemoryCacheService) { }

  ngOnInit(): void {
  }

}
